import { useState, useRef, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
//Action
// import {
//   updateOtpBySmsAction,
//   resendOtpBySMSAction,
//   confirmSignUpOtpBySmsAction,
//   adminRegisterAction,
//   resendSignUpOtpBySMSAction,
// } from "../store/action/admin/authActions";
import "react-phone-number-input/style.css"; // Import the CSS file for the default styling
import {
  Button,
  Col,
  Form,
  Input,
  Progress,
  Row,
  Tooltip,
  Typography,
  message,
} from "antd";
import AdminSignupPageCard from "../adminSignupPageCard";
import {
  confirmSignUpOtpBySmsAction,
  resendSignUpOtpBySMSAction,
} from "../../../../store/action/admin/authActions";
import ContactUsPopup from "../../../Pages/ContactUsPopup";

function AdminInvoiceSignupOTP() {
  const { Title } = Typography;
  const router = useNavigate();
  const dispatch = useDispatch();
  // const [form] = Form.useForm();

  const resendSignUpOtpBySmsList = useSelector(
    (state) => state.resendSignUpOtpBySmsList
  );
  const { resendSignUpOtpBySmsLoading, resendOtpBySmsError } =
    resendSignUpOtpBySmsList;

  const confirmSignUpOtpBySmsList = useSelector(
    (state) => state.confirmSignUpOtpBySmsList
  );
  const { confirmSignUpOtpBySmsLoading, confirmSignUpOtpBySmsError } =
    confirmSignUpOtpBySmsList;
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;

  const [otp, setOtp] = useState(Array(6).fill(""));
  const refs = useRef([]);

  const onClicked = async () => {
    try {
      const email = sessionStorage.getItem("email");
      const phoneNo = sessionStorage.getItem("phoneNo");
      const countryCode = sessionStorage.getItem("countryCode");
      let data = {
        email: email,
        number: phoneNo,
        countryCode: countryCode,
      };
      await dispatch(resendSignUpOtpBySMSAction(data));
      message.success("OTP Send Successfully");
      setProgress(100);
      setTimeRemaining(300000);
    } catch (error) {
      message.error("Contact to support!");
    }
  };

  const handleSubmit = async () => {
    try {
      const email = sessionStorage.getItem("email");
      const phoneNo = sessionStorage.getItem("phoneNo");
      const countryCode = sessionStorage.getItem("countryCode");
      const code = otp?.join("");

      let data = {
        phoneNo: phoneNo,
        countryCode: countryCode,
        otp: code,
        email: email,
      };

      await dispatch(confirmSignUpOtpBySmsAction(data));
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("phoneNo");
      sessionStorage.removeItem("countryCode");
      // form.resetFields();
      //   message.success("OTP Verified");
      router("/admin/company-setup", { replace: true });
    } catch (error) {
      message.error("Contact to support!");
    }
  };

  const handleOTPChange = (index) => (e) => {
    const { value } = e.target;
    const onlyNumbersPattern = new RegExp("^[0-9]+$");
    if (onlyNumbersPattern.test(value) || value === "") {
      setOtp((prevOTP) => {
        const newOTP = [...prevOTP];
        newOTP[index] = value;
        return newOTP;
      });

      if (value !== "") {
        if (index < 5) {
          refs.current[index + 1].focus();
        } else {
          refs.current[index].blur();
        }
      } else if (index > 0) {
        refs.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain");
    const otpArray = pastedData
      .slice(0, 6)
      .split("")
      .map((char) => (isNaN(parseInt(char, 10)) ? "" : char));
    setOtp(otpArray.concat(Array(6 - otpArray.length).fill("")));
  };

  const handleBackspace = (index) => (e) => {
    if (e.key === "Backspace" && otp[index] === "") {
      e.preventDefault(); // Prevent default backspace behavior
      if (index > 0) {
        setOtp((prevOTP) => {
          const newOTP = [...prevOTP];
          newOTP[index - 1] = "";
          return newOTP;
        });
        refs.current[index - 1].focus();
      }
    }
  };

  const otpStyle = {
    minHeight: "90vh",
    borderRadius: "32px",
    display: "flex",
    justifyContent: "center",
    /* flex-direction: column; */
    alignItems: "center",
    margin: "20px 0",
  };
  const twoColors = {
    "0%": "#f47e63",
    "100%": "#f47e63",
  };
  const [progress, setProgress] = useState(100);
  const duration = 300000; // 5 minutes in milliseconds
  const step = 0.01; // progress step size

  const [timeRemaining, setTimeRemaining] = useState(duration);

  useEffect(() => {
    startTimer();

    // Clean up interval
    return () => clearInterval(intervalRef.current);
  }, []);

  const intervalRef = useRef(null);

  const startTimer = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress > 0) {
          return prevProgress - 100 / (duration / (1000 * step));
        }
        clearInterval(intervalRef.current);
        return prevProgress;
      });
      setTimeRemaining((prevTime) => {
        if (prevTime > 0) {
          return prevTime - 1000 * step;
        }
        return 0;
      });
    }, 1000 * step); // Update progress every `step` seconds
  };

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <AdminSignupPageCard styled={otpStyle}>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          // margin: "0 250px",
        }}
      >
        <Col span={24} style={{ marginBottom: "20px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              gap: "5px",
            }}
          >
            <Title>Verify your phone number</Title>
            <p>Please enter 6-digit verification code sent:</p>
          </div>
        </Col>

        {/* input */}
        <Col span={24} style={{ marginBottom: "20px" }}>
          <Form
            name="normal_login"
            className="login-form"
            layout="vertical"
            autoComplete="on"
            initialValues={{
              remember: true,
            }}
            onFinish={handleSubmit}
          >
            <Form.Item
              noStyle
              name="otp"
              rules={[
                {
                  required: true,
                  message: "Enter the correct OTP",
                },
              ]}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  // gap: "25px",
                }}
              >
                {otp.map((digit, index) => (
                  <Input
                    // placeholder="0"
                    key={index}
                    maxLength={1}
                    value={digit}
                    onChange={handleOTPChange(index)}
                    onPaste={handlePaste}
                    onKeyDown={handleBackspace(index)}
                    style={{
                      border: "none",
                      borderRadius: "0px",
                      borderBottom: "1px solid black",
                      width: "50px",
                      height: "50px",
                      marginRight: "10px",
                      textAlign: "center",
                    }}
                    ref={(el) => (refs.current[index] = el)}
                  />
                ))}
              </div>
            </Form.Item>
          </Form>
        </Col>

        {/* submit button */}
        <Col
          span={20}
          style={{
            width: "100%",
            gap: "10px",
            marginBottom: "20px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {" "}
          {/* error */}
          {resendOtpBySmsError && (
            <p style={{ color: "red", textAlign: "center" }}>
              {resendOtpBySmsError}
            </p>
          )}
          {confirmSignUpOtpBySmsError && (
            <p style={{ color: "red", textAlign: "center" }}>
              {confirmSignUpOtpBySmsError}
            </p>
          )}
          {/* <Progress
            strokeColor={twoColors}
            percent={progress}
            showInfo={false}
            size="small"
          /> */}
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={resendSignUpOtpBySmsLoading}
            loading={confirmSignUpOtpBySmsLoading}
            style={{ width: "100%" }}
            size="large"
          >
            Continue
          </Button>
          {/* timer and resent otp */}
          {progress > 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Tooltip
                title={`Wait for the timer to run out before resending the OTP`}
              >
                <div>
                  <p
                    style={{
                      cursor: "default",
                      color: "rgb(0 0 0 / 40%)",
                    }}
                  >
                    Resend in
                  </p>{" "}
                </div>
              </Tooltip>
              <div>
                <p>{formatTime(timeRemaining)}</p>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div>
                <p
                  onClick={onClicked}
                  style={{
                    cursor: "pointer",
                    color: "rgba(0, 0, 0, 0.85)",
                  }}
                >
                  Resend
                </p>
              </div>
              <div>{/* <p>{formatTime(timeRemaining)}</p> */}</div>
            </div>
          )}
        </Col>
      </Row>
      <ContactUsPopup />
    </AdminSignupPageCard>
  );
}

export default AdminInvoiceSignupOTP;
